import React, { useState, useEffect } from 'react';
import { db } from '../firebaseConfig';
import { collection, query, where, onSnapshot } from 'firebase/firestore';
import { useAuth } from '../context/AuthContext';
import { IoWalletOutline } from 'react-icons/io5';
import './TrabajadorDashboardScreen.css';
import KondoSidebar from '../components/Shared/KondoSidebar';
import KondoBottomNav from '../components/Shared/KondoBottomNav';
import KondoBrandHeader from '../components/Shared/KondoBrandHeader';
import SafeAreaInsets from '../components/Shared/SafeAreaInsets';
import { openAuthenticatedInvoice } from '../utils/invoiceDownload';

function TrabajadorNominaScreen() {
  const { currentUser } = useAuth();
  const [nominas, setNominas] = useState([]);

  useEffect(() => {
    if (!currentUser) return;

    const qNominas = query(
      collection(db, "nominas_recibos"),
      where("trabajadorId", "==", currentUser.uid)
    );
    return onSnapshot(qNominas, (snap) => {
      const list = snap.docs.map(d => ({ id: d.id, ...d.data() }));
      list.sort((a, b) => (b.fechaPago || '').localeCompare(a.fechaPago || ''));
      setNominas(list);
    });
  }, [currentUser]);

  return (
    <div className="ks-page">
      <KondoSidebar activeRoute="/trabajador/nomina" />

      <main className="ks-main">
        <SafeAreaInsets top={false} bottom={true} />
        <KondoBrandHeader showBack={false} />

        <div className="ks-scroll-area">
          <div className="muro-header-stitch">
            <div className="muro-hero-card">
              <div className="muro-hero-content">
                <h1>Mi Nómina</h1>
                <p>Historial de recibos de nómina y pagos</p>
              </div>
              <IoWalletOutline className="muro-hero-icon-decor" />
            </div>
          </div>

          <div style={{ padding: '16px' }}>
            <div className="trabajador-card-premium" style={{ maxWidth: '600px', margin: '20px auto' }}>
            <div className="card-section-title">
              <IoWalletOutline size={24} style={{ color: '#7B61FF', marginRight: '8px' }} />
              <h3 style={{ fontSize: '1.25rem' }}>Historial de Recibos de Nómina</h3>
            </div>

            {nominas.length === 0 ? (
              <div className="dashboard-empty-state">
                <p>Aún no se han registrado recibos de nómina.</p>
              </div>
            ) : (
              <div className="receipts-list">
                {nominas.map(rec => (
                  <div key={rec.id} className="receipt-row" style={{ display: 'flex', flexDirection: 'column', gap: '8px', padding: '12px 0', borderBottom: '1px solid #f1f5f9' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                      <div>
                        <strong>Periodo: {rec.periodo || 'N/A'}</strong>
                        <p style={{ margin: 0, fontSize: '0.8rem', color: '#64748b' }}>Pagado el {rec.fechaPago}</p>
                      </div>
                      <span className="receipt-amount" style={{ fontWeight: '700', color: '#0f766e' }}>${rec.netoPagado?.toFixed(2) || '0.00'}</span>
                    </div>
                    
                    <div style={{ fontSize: '0.75rem', color: '#64748b' }}>
                      Sueldo Base: ${rec.sueldoBruto?.toFixed(2)} | Bonos: ${rec.bonos?.toFixed(2)} | Deducciones: -${rec.deducciones?.toFixed(2)}
                    </div>

                    {rec.facturapiReceiptId && (
                      <div style={{ display: 'flex', gap: '8px' }}>
                        <button 
                          onClick={() => openAuthenticatedInvoice(rec.facturapiReceiptId, 'pdf').catch(console.error)}
                          style={{
                            padding: '4px 8px',
                            borderRadius: '6px',
                            border: '1px solid #cbd5e1',
                            background: 'white',
                            fontSize: '0.75rem',
                            cursor: 'pointer',
                            fontWeight: '600',
                            color: '#475569'
                          }}
                        >
                          📄 PDF SAT
                        </button>
                        <button 
                          onClick={() => openAuthenticatedInvoice(rec.facturapiReceiptId, 'xml').catch(console.error)}
                          style={{
                            padding: '4px 8px',
                            borderRadius: '6px',
                            border: '1px solid #cbd5e1',
                            background: 'white',
                            fontSize: '0.75rem',
                            cursor: 'pointer',
                            fontWeight: '600',
                            color: '#475569'
                          }}
                        >
                          ⚙️ XML SAT
                        </button>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </main>

      <KondoBottomNav activeRoute="/trabajador/nomina" />
    </div>
  );
}

export default TrabajadorNominaScreen;
